// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1YLDX","label":"Labeled_label__1pQsq","divider":"Labeled_divider__y-Kgd"};